import {confirmAlert} from "react-confirm-alert";
import React from "react";
import ChecklistProjectNADialog from "../../../components/ChecklistProjectNADialog";
import Alert from "../../../components/Alert";
import {undoNAProjectStatus} from "../../../api";

const bodyStyle = {
    margin: "1.5rem"
}

const ChecklistProjectNAConfirmDialogBody = () => (
    <div style={bodyStyle}>
        <div>The project needs to be reactivated before updates can be made when the project is Checklist N/A.</div>
    </div>
);

const ShowChecklistProjectConfirmDialog = (project, history, context) => {

    const options = {
        closeOnEscape: true,
        customUI: ({ onClose }) => <ChecklistProjectNADialog
            onClose={ onClose }
            onAccept={ () => {
                callProjectNA(project, history, context);
                onClose();
            }}
            body={<ChecklistProjectNAConfirmDialogBody  />}
        />
    };

    confirmAlert(options);
};

async function callProjectNA(project, history, context)
{
    const {
        setLaunchDashboard,
        setActiveDashboardTab
    } = context
    const result = await undoNAProjectStatus(project);
    if(result === 'PREFORM_EXCEPTION_DELETE_ERROR')
    {
        PreFormExceptionDeleteError();
        return;
    }
    if (result !== "UNDO_NA") {
        InvalidDataConfirm();
    }
    else {
        setActiveDashboardTab('N');
        setLaunchDashboard(true);
    }
}
function InvalidDataConfirm ()  {
    let msg = "Undo NA Status was not properly done...";
    confirmAlert({
        customUI: ({onClose}) => {
            return (
                <Alert msg={msg} onClose={onClose} />
            );
        }
    });
};

function PreFormExceptionDeleteError()  {
    let msg = "This project has either an Energized Pre-E Form or an Exception that has been Approved or is Waiting on Responses. " +
        "You cannot move this to N/A. Please contact Checklist Support to delete this exception and/or Pre-E form if necessary.";
    confirmAlert({
        customUI: ({onClose}) => {
            return (
                <Alert msg={msg} onClose={onClose} />
            );
        }
    });
};

export default ShowChecklistProjectConfirmDialog;